import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-14 px-4 sm:px-6 bg-white" data-id="element-83">
      <div className="text-center mb-8" data-id="element-84">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-3 uppercase leading-tight" data-id="element-85">
          YOUR INVESTMENT IS 100% PROTECTED
        </h2>
      </div>

      <div className="bg-brand-paper border-2 border-brand-sage p-8 sm:p-10 rounded-2xl text-center shadow-lg max-w-3xl mx-auto relative overflow-hidden" data-id="element-86">
        <div className="absolute top-0 left-0 w-full h-2 bg-brand-sage" data-id="element-87" />

        <div className="w-20 h-20 mx-auto bg-brand-sage/10 rounded-full flex items-center justify-center mb-6 border border-brand-sage/30" data-id="element-88">
          <ShieldCheck className="w-10 h-10 text-brand-sage" data-id="element-89" />
        </div>
        <h3 className="text-xl sm:text-2xl font-heading font-black text-brand-navy mb-4 uppercase leading-tight" data-id="element-90">
          🛡️ 7-Day Money-Back Guarantee
        </h3>
        <p className="text-base font-bold text-brand-ink mb-5 uppercase tracking-wide" data-id="element-91">
          Your purchase is completely risk-free.
        </p>
        <p className="text-sm sm:text-base text-brand-ink/80 leading-relaxed mb-5" data-id="element-92">
          Take seven full days to explore the entire system, review every
          module, implement the templates, organize your workflow, and start
          using the resources with your patients.
        </p>
        <p className="text-sm sm:text-base text-brand-ink/80 leading-relaxed font-medium" data-id="element-93">
          If for any reason you're not completely satisfied, simply contact us
          within the first 7 days and we'll refund 100% of your purchase.
          <br data-id="element-94" />
          <span className="text-brand-sage font-bold block mt-2" data-id="element-95">
            No risk. No questions asked.
          </span>
        </p>
      </div>
    </section>;
}